import { Component, OnInit, EventEmitter, Output, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { OtpService } from 'src/app/services/checkout-services/-otp.service';
import { LoginService } from 'src/app/services/checkout-services/login.service';
import { CookieService } from 'ngx-cookie-service';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ServiceBody } from 'src/app/models/serviceBody';
import { AddressService } from 'src/app/services/checkout-services/address.service';
import { Login } from '../../../models/User';
import { response } from 'src/app/models/response';
import { List } from "immutable";
import { AddressSuccess } from 'src/app/models/address';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  @Output() redirect: EventEmitter<any> = new EventEmitter();
  @Output() redirect2: EventEmitter<any> = new EventEmitter();

  @Output() redirect5: EventEmitter<any> = new EventEmitter();
  serviceBody = new ServiceBody();
  NewLogin = new Login();

  myNumber: string;
  showStart = true;
  showLogin: boolean = false;
  showSignup = false;
  showMessage = false;
  myLoginPassword: string;
  mySignupPassword: string;
  otpId: string;
  userId: string;
  addressId: string;
  shippingAddressId:string;
  hide = true;
  constructor(private router: Router,
    public otpService: OtpService,
    public loginService: LoginService,
    private _cookie: CookieService,
    private _bottomSheetRef: MatBottomSheetRef,
    private addressService: AddressService,
    private ngZone: NgZone,
  ) { }

  userExist() {
    this.loginService.checkUser(this.myNumber).subscribe(data => {
      document.getElementById('showLogin').style.display = 'block'
      document.getElementById('button').style.display = 'none'
      document.getElementById('input').style.display = 'none'
    },
      error => {
        if (this.myNumber) {
          this.generateOtp();
        }
      });

  }

  forgetPassword() {
    this.otpService.sendOtp(this.myNumber).subscribe(data => {
      this.redirect5.emit(this.showSignup);
      this.showMessage = !this.showMessage;
      this.serviceBody.myNumber = this.myNumber;
      this.serviceBody.mySignupPassword = '';
      this.serviceBody.otpId = data.body.otpId;
      this.serviceBody.address = '';
      this.serviceBody.name = '';
      this.serviceBody.userId = '';
      this.redirect.emit(this.serviceBody);
      this.redirect2.emit(true);
    });
  }


  generateOtp() {
    this.otpService.sendOtp(this.myNumber).subscribe(data => {
      this.redirect5.emit(this.showSignup);

      this.showMessage = !this.showMessage;

      this.serviceBody.myNumber = this.myNumber;
      this.serviceBody.mySignupPassword = '';
      this.serviceBody.otpId = data.body.otpId;
      this.serviceBody.address = '';
      this.serviceBody.name = '';
      this.serviceBody.userId = '';
      this.redirect.emit(this.serviceBody);
      this.redirect2.emit(false)
    });

  }

  loginUser() {
    this.NewLogin.phoneNumber = this.myNumber;
    this.NewLogin.password = this.myLoginPassword;
    this.loginService.loginUser(this.NewLogin).subscribe(data => {
      this.addressService.getAddress(data.headers.get('userID'), data.headers.get('Authorization')).subscribe(response => {
        const billingAddresses: List<AddressSuccess> = List(response.body.billingAddresses);
        const shippingAddresses: List<AddressSuccess> = List(response.body.shippingAddresses);
        let address = null;
        let shippingAddress=null;
        if (shippingAddresses != null && !shippingAddresses.isEmpty()) {
          shippingAddress = shippingAddresses.get(0)
        }

        if (billingAddresses != null && !billingAddresses.isEmpty()) {
          address = billingAddresses.get(0);
        }

        if (address != null) {
          this.addressId = address.addressId;
          this._cookie.set('addressId', this.addressId);
        }
        if(shippingAddress!=null){
          this.shippingAddressId=shippingAddress.addressId;
          this._cookie.set("shippingAddressId", this.shippingAddressId)
        }

        this.showMessage = !this.showMessage;
        this._cookie.set('Authorization', data.headers.get('Authorization')),
          this._cookie.set('UserID', data.headers.get('UserID'));
        if (this._cookie.get('productId')) {
          this.ngZone.run(() =>
            this.router.navigate(['/order-and-address']));
        } else {
          this.ngZone.run(() =>
            this.router.navigate(['/my-account']));
        }
      }, error => {
        this.showMessage = !this.showMessage;
        this._cookie.set('Authorization', data.headers.get('Authorization')),
          this._cookie.set('UserID', data.headers.get('UserID'));
        if (this._cookie.get('productId')) {
          this.ngZone.run(() =>
            this.router.navigate(['/order-and-address']));
        } else {
          this.ngZone.run(() =>
            this.router.navigate(['/my-account']));
        }
      });

      this._bottomSheetRef.dismiss();
    }, error => {
      document.getElementById('error').style.display = 'block';
      document.getElementById('noError').style.display = 'none';
      this.myLoginPassword = '';
    });
  }
  ngOnInit() {
    document.getElementById('button').style.display = 'block'
    document.getElementById('input').style.display = 'block'
    document.getElementById('showSignup').style.display = 'none';
    document.getElementById('showLogin').style.display = 'none';
    document.getElementById('error').style.display = 'none';
    document.getElementById('noError').style.display = 'block'
  }

}
